import Vue from "vue";
import BaseFooter from "./BaseFooter.vue";
const Components = {
    BaseFooter
};
Object.keys(Components).forEach(name => {
  Vue.component(name, Components[name]);
});
export default Components;
